import { IAlert } from "@/core/models/alert.model";

// action types
export const CLOSE_ALERT = "closeAlert";

// mutation types
export const SET_ALERT = "setAlert";

const state: IAlert = {
  text: "",
  isError: false,
  visibility: false,
};

const getters = {
  alertVisibility(state: IAlert) {
    return state.visibility;
  },
  alertText(state: IAlert) {
    return state.text;
  },
  alertError(state: IAlert) {
    return state.isError;
  },
};

const actions = {
  [CLOSE_ALERT](context: any) {
    // for better show :
    context.commit(SET_ALERT, {
      // first hide the snackbar
      text: state.text,
      isError: state.isError,
      visibility: false,
    });
    setTimeout(() => {
      // then reset the "text" and "isError"
      context.commit(SET_ALERT, {
        text: "",
        isError: false,
        visibility: state.visibility,
      });
    }, 100);
  },
};

const mutations = {
  [SET_ALERT](state: IAlert, data: IAlert) {
    state.visibility = data.visibility ?? true;
    state.text = data.text;
    state.isError = data.isError;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
